import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExcursionContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownExcursionContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownExcursionContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownExcursionContracts/${id}`, request)
}

export {get, post, put, patch}
